import { useState, useEffect, useCallback } from "react";

/**
 * Poll CLEAR taxis from TaxiCRM (via /api/taxis-live) every 15 seconds,
 * overlaying them on the livebus map alongside the live buses.
 *
 * Source: livebus reads the TaxiCRM postgres directly (TAXICRM_DATABASE_URL),
 * same working pattern as api/taxi-eta.js. Returns only CLEAR taxis with
 * live lat/lng.
 */
export function useLiveTaxis() {
  const [taxis, setTaxis] = useState([]);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  const doFetch = useCallback(async () => {
    try {
      const res = await fetch("/api/taxis-live");
      if (!res.ok) throw new Error(`taxis-live ${res.status}`);
      const data = await res.json();
      setTaxis(Array.isArray(data.taxis) ? data.taxis : []);
      setLastUpdated(new Date());
      setError(null);
    } catch (err) {
      setError("Live taxis unavailable");
      // keep last known taxis on the map instead of clearing them
    }
  }, []);

  useEffect(() => {
    let interval = null;
    const timer = setTimeout(() => {
      doFetch();
      interval = setInterval(doFetch, 15000);
    }, 400);

    return () => {
      clearTimeout(timer);
      if (interval) clearInterval(interval);
    };
  }, [doFetch]);

  return { taxis, error, lastUpdated };
}
